export default __webpack_public_path__ + "static/media/FogHorn.cfdfc9f5.png";